import './App.css';
import { AuthProvider } from './context/AuthContext';
import Catalog from './pages/Catalog';

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Catalog />
      </div>
    </AuthProvider>
  );
}

export default App;
